<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <PrimeMenu ref="primeMenu" :model="filteredActionsWithDivider" popup>
    <template #item="{ item, props }">
      <PrimeDivider v-if="item.separator" class="my-1" />
      <template v-else>
        <router-link
          v-if="item.route"
          v-slot="routerProps"
          :to="item.route"
          custom
        >
          <a
            :href="routerProps.href"
            v-bind="props.action"
            class="flex align-items-center px-3 py-2"
          >
            <span :class="item.icon" class="mr-2" />
            <span>{{ item.label }}</span>
          </a>
        </router-link>
        <a
          v-else
          :href="item.url"
          v-bind="props.action"
          class="flex align-items-center px-3 py-2"
        >
          <span :class="item.icon" class="mr-2" />
          <span>{{ item.label }}</span>
        </a>
      </template>
    </template>
  </PrimeMenu>
</template>

<script>
import Divider from "primevue/divider";
import Menu from "primevue/menu";

export default {
  name: "ActionMenu",
  components: {
    PrimeDivider: Divider,
    PrimeMenu: Menu,
  },
  props: {
    actionMenuItems: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getActionMenuRef() {
      return this.$refs.primeMenu;
    },
  },
  computed: {
    filteredActionsWithDivider() {
      return this.actionMenuItems
        .map((group) => group.items.filter((item) => item.visible !== false)) // garder uniquement les visibles
        .filter((groupItems) => groupItems.length > 0) // ignorer les groupes vides
        .flatMap((items, index, array) => {
          const withDivider = index < array.length - 1;
          return withDivider ? [...items, { separator: true }] : items;
        });
    },
  },
};
</script>

<style scoped></style>
